/**
 * ¿Cae el punto (lat, lng) dentro del polígono GeoJSON (Polygon o MultiPolygon)?
 * Ray casting sobre lng/lat; respeta huecos (anillos interiores).
 *
 * Devuelve `null` si no hay polígono o no se puede leer: sin polígono no se puede
 * afirmar que el punto esté fuera.
 */
export function isPointInGeoJson(lat: number, lng: number, geoJson: string | null | undefined): boolean | null {
  if (!geoJson) return null
  let geometry: { type?: string; coordinates?: unknown }
  try {
    const parsed = JSON.parse(geoJson)
    geometry = parsed?.type === 'Feature' ? parsed.geometry : parsed
  } catch {
    return null
  }

  const polygons: number[][][][] =
    geometry?.type === 'Polygon'
      ? [geometry.coordinates as number[][][]]
      : geometry?.type === 'MultiPolygon'
        ? (geometry.coordinates as number[][][][])
        : []
  if (polygons.length === 0) return null

  return polygons.some((rings) => {
    const [outer, ...holes] = rings
    if (!outer || !inRing(lng, lat, outer)) return false
    return !holes.some((hole) => inRing(lng, lat, hole))
  })
}

function inRing(x: number, y: number, ring: number[][]): boolean {
  let inside = false
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const [xi, yi] = ring[i]
    const [xj, yj] = ring[j]
    const crosses = yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    if (crosses) inside = !inside
  }
  return inside
}
